.innerCarouselItem {
  height: 100%;
  min-width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  cursor: default;
}

.innerCarouselImg {
  width: 100%;
  height: 100%;
}

.stockPhotoLabel {
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
}
